import { AppProvider } from './providers';
import { AppRouter } from './routes';
import { SessionExpiredModal } from '@/components/auth/SessionExpiredModal';
import { ToastViewport } from '@/components/ui';

export function App() {
  return (
    <AppProvider>
      <AppRouter />
      <SessionExpiredModal />
      <ToastViewport />
    </AppProvider>
  );
}
